// extracted by mini-css-extract-plugin
export default {"background":"TabContent_background__fQbgM","contentContainer":"TabContent_contentContainer__jBhGd"};